import { Box, IBoxProps } from 'native-base';
import React, { ReactNode } from 'react';
import Collapsible from 'react-native-collapsible';

type CollapsibleContentProps = IBoxProps & {
  children: ReactNode;
  collapsed: boolean;
  collapsible: boolean;
};

export default function CollapsibleContent({
  children,
  collapsed,
  collapsible,
  ...boxProps
}: CollapsibleContentProps) {
  if (collapsible) {
    return (
      <Collapsible collapsed={collapsed} renderChildrenCollapsed>
        <Box {...boxProps}>{children}</Box>
      </Collapsible>
    );
  }
  return <Box {...boxProps}>{children}</Box>;
}
